import DAILY_JSON from '../../env-daily.json'
import STAGING_JSON from '../../env-staging.json'
import PRODUCTION_JSON from '../../env-production.json'
import { info } from '@/lib/logger'
import type { Environment } from '@/types/types'

/**
 * Set runtime environment variables
 */
export const initEnvironment = (): void => {
  // set environment variables for app
  setEnvVars()
  setLocalStyle()
}

/**
 * Set what environment variables to use at runtime
 */
export const setEnvVars = (): void => {
  if (isDaily()) {
    window.environment = DAILY_JSON as Environment
  } else if (isStaging()) {
    window.environment = STAGING_JSON as Environment
  } else if (isProduction()) {
    window.environment = PRODUCTION_JSON as Environment
  } else {
    throw new Error('Failed to set environment')
  }

  info('Logger', 'RUNTIME ENV: ', getEnv())
}

/**
 * Use local carto service for stylesheet if enabled
 */
export const setLocalStyle = (): void => {
  if (process.env.LOCAL_STYLE) {
    window.environment.cartoUrl = 'http://localhost:8080'

    info('Map', 'Using local carto service at', window.environment.cartoUrl)
  }
}

/**
 * Are we at the daily origin domain
 */
export const isDailyOrigin = (): boolean =>
  window.location.origin === 'https://webmap.daily.onxmaps.com'

/**
 * Are we at the staging origin domain
 */
const isStagingOrigin = (): boolean =>
  document.location.origin === 'https://webmap.staging.onxmaps.com'

/**
 * Get runtime environment
 */
// FUTURE - remove
export const getEnv = (): string | undefined => {
  if (isDailyOrigin()) {
    return 'daily'
  }
  if (isStagingOrigin()) {
    return 'staging'
  }
  return process.env.RUNTIME_ENV
}

/**
 * Are we in daily env
 */
export const isDaily = (): boolean => getEnv() === 'daily'

/**
 * Are we in staging env
 */
export const isStaging = (): boolean => getEnv() === 'staging'

/**
 * Are we in production env
 */
export const isProduction = (): boolean => getEnv() === 'production'
